import React from 'react'

import { F0Icon } from '@factorialco/f0-react'
import { Sparkles } from '@factorialco/f0-react/icons/app'
import { AvailableModules } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

// Transparent 1x1 PNG — the Lovable design shows a text-only banner,
// but UpsellingBanner requires a mediaUrl. This avoids a broken-image icon.
const TRANSPARENT_PIXEL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

export const DeviceCatalogPromoBanner: React.FC = () => {
  return (
    <UpsellingKit.ProductBanner
      moduleRequested={AvailableModules.it_management}
      requestSource="Device Catalog - promo banner"
      requestReason={ValidReasons.MissingAddon}
      title={i18n.t('it_management.device_catalog.promo_banner.title')}
      subtitle={i18n.t('it_management.device_catalog.promo_banner.description')}
      mediaUrl={TRANSPARENT_PIXEL}
      loadingComponent={null}
      primaryAction={{
        label: i18n.t('it_management.device_catalog.promo_banner.cta'),
        variant: 'outline',
        icon: <F0Icon icon={Sparkles} size="sm" />,
      }}
    />
  )
}
